import React from "react"
import {Dispatch} from "redux"
import {connect} from "react-redux"

// Actions
import * as a from "../store/actions"

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    signOut: () => dispatch(a.signOutAsync.request()),
});

/**
 * @param BaseComponent
 */
export default function withSignOut(BaseComponent: React.ComponentType<any>) {
    return connect(null, mapDispatchToProps)(BaseComponent)
}

export type WithSignOutProps = {
    signOut(): void
}
